module.exports = __webpack_public_path__ + "img/leicht_und_bewegt.22f7739c.png";